import React, { useEffect, useState } from 'react';
import { heroTaglines } from '../config/taglines';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [currentTaglineIndex, setCurrentTaglineIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const taglinesCount = heroTaglines.length;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const intervalId = setInterval(() => {
      setIsAnimating(true);
      timeoutId = setTimeout(() => {
        setCurrentTaglineIndex((prev) => (prev + 1) % taglinesCount);
        setIsAnimating(false);
      }, 600);
    }, 6000);

    return () => {
      clearInterval(intervalId);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <footer className="border-t border-solid border-t-border py-8">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between gap-6 sm:flex-row">
          <div className="flex flex-col items-center gap-2 sm:items-start">
            <div className="flex items-center gap-3 text-white">
              {/* <Logo className="size-14 text-secondary" /> */}
              <h2 className="text-white text-3xl font-semibold">recalibr<span className="text-secondary">.ai</span></h2>
            </div>
            <p className="text-base text-muted">© {currentYear} Recalibr AI. All rights reserved.</p>
          </div>
          <div className="flex-1 flex items-center justify-center px-6">
            <p className={`text-lg text-text italic transition-opacity duration-500 ease-in-out text-center ${
              isAnimating ? 'opacity-0' : 'opacity-100'
            }`}>
              {heroTaglines[currentTaglineIndex]}
            </p>
          </div>
          <div className="flex items-center gap-4">
            <a className="text-muted transition-colors hover:text-white" href="https://ae.linkedin.com/in/luvsuneja" target="_blank" rel="noopener noreferrer">
              <svg fill="currentColor" height="24" viewBox="0 0 256 256" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M216,24H40A16,16,0,0,0,24,40V216a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V40A16,16,0,0,0,216,24Zm0,192H40V40H216V216ZM96,112v64a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0Zm88,28v36a8,8,0,0,1-16,0V140a20,20,0,0,0-40,0v36a8,8,0,0,1-16,0V112a8,8,0,0,1,15.79-1.78A36,36,0,0,1,184,140ZM100,84A12,12,0,1,1,88,72,12,12,0,0,1,100,84Z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
